import { Card, makeStyles, Theme, Typography } from '@freighthub/silhouette-core'
import { config } from 'app/config'
import { FC, PropsWithChildren } from 'react'

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    minHeight: '420px',
    height: `calc(100% + ${theme.spacing(4)})`, // this is here because app layout has padding
    margin: theme.spacing(-2),
    backgroundImage: `url("${config.STATIC_ASSETS_URL}/images/hamburg-port.jpg")`,
    backgroundSize: 'cover',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    width: '500px',
    padding: theme.spacing(5),
  },
  title: {
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
}))

type LoginRootCardProps = {
  title: string
}

export const LoginRootCard: FC<PropsWithChildren<LoginRootCardProps>> = ({ title, children }) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <Typography variant="h5" className={classes.title}>
          {title}
        </Typography>
        {children}
      </Card>
    </div>
  )
}
